import { IFormsTemplateRepository } from "domain/contracts/formstemplate.contract";
import { FormTemplate } from "domain/entities/form-template";
import { FormsTemplateInputFilter } from "domain/models/nimberforms-input-filters";
import { httpClient } from "infra/axios/axios-api";
import { Message } from "domain/entities/message";

export type formTemplateData = {
    title: string; 
    description: string; 
    config: string; 
    active: boolean;
}

export type formTemplateUpdateInput = {
    id: string;
} & formTemplateData;
class FormsTemplateRepository implements IFormsTemplateRepository{

    async getAll(filter: FormsTemplateInputFilter): Promise<Message<FormTemplate[]>> {
        const response = await httpClient.get("/formsTemplate", {params: filter});

        return response.data;
    }

    async getById(id: string): Promise <Message<FormTemplate>>{
        const response = await httpClient.get(`/formsTemplate/${id}`);
        return response.data;
    }

    async createTemplate(template: {title: string, description: string, config: string, active: boolean}): Promise<Message<FormTemplate>> {
        const response = await httpClient.post('/formsTemplate', {data: template});
        return response.data;
    }

    async updateTemplate(template: formTemplateUpdateInput): Promise<Message<FormTemplate>> {
        const {id, ...data} = template;
        const response = await httpClient.put(`/formsTemplate/${id}`, { data: data});
        return response.data;
    }

    async deleteTemplate(id: string): Promise<Message<FormTemplate>> {
        const response = await httpClient.delete(`/formsTemplate/${id}`);
        return response.data;
    }

}

export default new FormsTemplateRepository();